<template>
  <div class="grid grid-cols-2 gap-3 sm:grid-cols-1">
    <AppInput
      :mode="mode"
      :id="`${id}-company`"
      title="Company"
      v-model="local.company"
      @input="emit"
    />
    <AppInput
      :mode="mode"
      :id="`${id}-contact`"
      title="Contact name"
      v-model="local.contact_name"
      @input="emit"
    />
    <AppInput
      :mode="mode"
      :id="`${id}-email`"
      title="Email"
      v-model="local.email"
      @input="emit"
    />
    <AppInput
      :mode="mode"
      :id="`${id}-phone`"
      title="Phone"
      v-model="local.phone"
      @input="emit"
    />
    <div class="col-span-2 sm:col-span-1">
      <label class="mb-1 block font-semibold">Details (one per line)</label>
      <textarea
        v-model="detailsText"
        rows="4"
        class="w-full rounded border p-2 text-[14px]"
        @input="emit"
      />
    </div>
  </div>
</template>

<script>
import AppInput from "@C/Form/AppInput.vue";

let _seq = 0;

export default {
  name: "PartyForm",
  components: { AppInput },
  props: {
    modelValue: { type: Object, default: () => ({}) },
    mode: { type: String, default: "light" },
  },
  emits: ["update:modelValue"],
  data() {
    _seq += 1;
    return {
      id: `party-${_seq}`,
      local: {
        company: this.modelValue.company || "",
        contact_name: this.modelValue.contact_name || "",
        email: this.modelValue.email || "",
        phone: this.modelValue.phone || "",
        details: Array.isArray(this.modelValue.details)
          ? [...this.modelValue.details]
          : [],
      },
      detailsText: (this.modelValue.details || []).join("\n"),
    };
  },
  watch: {
    modelValue: {
      handler(v) {
        if (!v) return;
        this.local = {
          company: v.company || "",
          contact_name: v.contact_name || "",
          email: v.email || "",
          phone: v.phone || "",
          details: Array.isArray(v.details) ? [...v.details] : [],
        };
        this.detailsText = (v.details || []).join("\n");
      },
      deep: true,
    },
  },
  methods: {
    emit() {
      const details = this.detailsText
        .split("\n")
        .map((s) => s.trim())
        .filter((s) => s.length > 0);
      this.$emit("update:modelValue", {
        company: this.local.company,
        contact_name: this.local.contact_name,
        email: this.local.email,
        phone: this.local.phone,
        details,
      });
    },
  },
};
</script>
